import { defaultApi } from '@/plugins/api/defaultApi'
import { sleep } from '@/util'

export default {
  name: 'terms',
  namespaced: true,
  state: {
    termses: [],
  },
  getters: {},
  mutations: {
    setTermses(state, termses) {
      state.termses = termses
    },
  },
  actions: {
    async getTerms({ commit }) {
      // api 호출
      const {
        data: { results },
      } = await defaultApi.getTerms()
      // 갖고온 데이터 리턴
      commit('setTermses', results)
      return results
    },
    async getTermsTemp({}) {
      // api 호출
      const { data } = await defaultApi.getTerms()
      // 갖고온 데이터 리턴
      return data
    },
    async getTermsDetail({}, { uuid }) {
      const { data } = await defaultApi.getTermsDetail({ uuid })
      return data
    },
  },
}
